var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet-icon",
    transform: "translate(-1407 -2684)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4791",
    "data-name": "Rectangle 4791",
    width: 24,
    height: 24,
    transform: "translate(1407 2684)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons_Wallet_Line",
    "data-name": "icons/Wallet/Line",
    transform: "translate(1409 2686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M15,1.667H3.333A1.667,1.667,0,0,0,1.667,3.333v8.333a1.667,1.667,0,0,0,1.667,1.667H15a1.667,1.667,0,0,0,1.667-1.667V3.333A1.667,1.667,0,0,0,15,1.667ZM3.333,0A3.333,3.333,0,0,0,0,3.333v8.333A3.333,3.333,0,0,0,3.333,15H15a3.333,3.333,0,0,0,3.333-3.333V3.333A3.333,3.333,0,0,0,15,0Z",
    transform: "translate(0.833 2.5)",
    fill: "#6b6b95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M0,4.167A4.167,4.167,0,0,1,4.167,0H7.5a.833.833,0,0,1,0,1.667H4.167a2.5,2.5,0,0,0,0,5H7.5a.833.833,0,0,1,0,1.667H4.167A4.167,4.167,0,0,1,0,4.167Z",
    transform: "translate(10.833 5.833)",
    fill: "#6b6b95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M1.667.833A.833.833,0,1,1,.833,0,.833.833,0,0,1,1.667.833Z",
    transform: "translate(14.167 9.167)",
    fill: "#6b6b95"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.814dbefe426015524d80c4e1dd7befb9.svg";
export { ForwardRef as ReactComponent };